export default __webpack_public_path__ + "static/media/utility6.3493d30d.svg";